export default __webpack_public_path__ + "static/media/IconSetting.ebf6df07.svg";